import { updateTherapistDocument } from "../firebase";
import { setTherapistProfile } from "../store/slices/authSlice";

export const REFERRAL_SOURCE_OTHER = "__other__";

export const DEFAULT_REFERRAL_SOURCE_OPTIONS = [
  { value: "facebook", label: "פייסבוק" },
  { value: "instagram", label: "אינסטגרם" },
  { value: "tiktok", label: "טיקטוק" },
  { value: "google", label: "גוגל / חיפוש" },
  { value: "website", label: "אתר האינטרנט שלנו" },
  { value: "recommendation", label: "המלצה" },
  { value: "friend", label: "חבר מביא חבר" },
  { value: "family", label: "בן/בת משפחה" },
  { value: "doctor_referral", label: "הפניה מרופא" },
  { value: "health_fund", label: "קופת חולים" },
  { value: "tipat_halav", label: "טיפת חלב" },
  { value: "school", label: "מסגרת חינוכית" },
  { value: "previous_patient", label: "מטופל קיים" },
  { value: "newsletter", label: "ניוזלטר / אימייל" },
  { value: "ad", label: "פרסומת בתשלום" },
];

const isLegacyOther = (value) => value === "other";

export const getCustomReferralSources = (therapistProfile) =>
  Array.isArray(therapistProfile?.customReferralSources)
    ? therapistProfile.customReferralSources
    : [];

export const getReferralSourceLabel = (value, therapistProfile) => {
  if (!value) return "—";
  if (isLegacyOther(value)) return "אחר";
  const def = DEFAULT_REFERRAL_SOURCE_OPTIONS.find((o) => o.value === value);
  if (def) return def.label;
  const custom = getCustomReferralSources(therapistProfile).find(
    (o) => o.value === value
  );
  if (custom) return custom.label;
  return value;
};

export const isKnownReferralSource = (value, therapistProfile) => {
  if (!value) return true;
  if (isLegacyOther(value)) return true;
  if (DEFAULT_REFERRAL_SOURCE_OPTIONS.some((o) => o.value === value)) return true;
  return getCustomReferralSources(therapistProfile).some(
    (o) => o.value === value
  );
};

export const persistCustomReferralSource = async ({
  value,
  therapistId,
  therapistProfile,
  dispatch,
}) => {
  if (!value || !therapistId || !therapistProfile || !dispatch) return;
  const trimmed = String(value).trim();
  if (!trimmed || isLegacyOther(trimmed)) return;
  if (DEFAULT_REFERRAL_SOURCE_OPTIONS.some((o) => o.value === trimmed)) return;
  const customSources = getCustomReferralSources(therapistProfile);
  if (customSources.some((o) => o.value === trimmed)) return;
  const newSources = [...customSources, { value: trimmed, label: trimmed }];
  try {
    await updateTherapistDocument(therapistId, {
      customReferralSources: newSources,
    });
    dispatch(
      setTherapistProfile({
        ...therapistProfile,
        customReferralSources: newSources,
      })
    );
  } catch (error) {
    console.error("[CK-2005] Failed to save custom referral source:", {
      errorCode: "CK-2005",
      errorMessage: error.message,
      therapistId,
      timestamp: new Date().toISOString(),
    });
  }
};
